module.exports = __webpack_public_path__ + "static/demo_1-abf7d2ad97f44fe038dad0e2ff16e589.svg";